import httpErrorMessages from "./../constant/httpErrorMessages";

const globalMixin = {
  data() {
    return {
      globalData: {
        deletionSuccessMessage: "Deleted Successfully"
      }
    };
  },
  computed: {
    configJSON() {
      return this.$store.state.config.config;
    }
  },
  methods: {
    snackbar(type, message) {
      this.$buefy.snackbar.open({
        duration: 2000,
        message,
        type, //"is-success", "is-danger", "is-warning", "is-info"
        position: "is-top",
        actionText: "x"
      });
    },

    // Mixin for error message //
    $_globalMixin_errorMessage(error) {
      const { format } = require("date-fns");
      let message = "";
      const status = error.response ? error.response.status : null;
      const currentDate = format(new Date(), "dd/MM/yyy HH:mm:ss");

      const hereHyperlinkURL =
        this.$store.state.config.configurationData.environment === "prd"
          ? "https://www.cea.gov.sg/feedback"
          : "/aceas/feedback-management";

      const parseValidationError = data => {
        let result = "";
        for (const [key, value] of Object.entries(data)) {
          result += key + " : ";
          result += Array.isArray(value) ? value.toString() : value;

          result += "<br /><br />";
        }

        return result;
      };

      switch (status) {
        case 400:
          // message = httpErrorMessages[400](currentDate);
          if (
            error.response &&
            error.response.data &&
            error.response.data.data &&
            error.response.data.data.message
          ) {
            const dateTimeText = `<p>Date and Time : ${currentDate}</p>`;

            message = Array.isArray(error.response.data.data.message)
              ? error.response.data.data.message.toString() +
                "<br /><br />" +
                dateTimeText
              : error.response.data.data.message
              ? error.response.data.data.message + "<br /><br />" + dateTimeText
              : typeof error.response.data.data === "object"
              ? parseValidationError(error.response.data.data) + dateTimeText
              : JSON.stringify(error.response.data.data) +
                "<br /><br />" +
                dateTimeText;
          } else {
            if (
              error.response &&
              error.response.data &&
              error.response.data.data
            ) {
              const dateTimeText = `<p>Date and Time : ${currentDate}</p>`;
              message =
                typeof error.response.data.data === "object"
                  ? parseValidationError(error.response.data.data) +
                    dateTimeText
                  : JSON.stringify(error.response.data.data) +
                    "<br /><br />" +
                    dateTimeText;
            } else {
              message = httpErrorMessages[400](currentDate, hereHyperlinkURL);
            }
          }

          break;
        case 401:
          message = httpErrorMessages[401](currentDate, hereHyperlinkURL);

          break;
        case 403:
          message = httpErrorMessages[403](currentDate, hereHyperlinkURL);

          break;
        case 404:
          message = httpErrorMessages[404](currentDate, hereHyperlinkURL);

          break;
        case 408:
          message = httpErrorMessages[408](currentDate, hereHyperlinkURL);

          break;
        case 500:
          if (
            error.response &&
            error.response.data &&
            error.response.data.data &&
            error.response.data.data.correlationId
          ) {
            const correlationId = error.response.data.data.correlationId;
            message = httpErrorMessages[500](
              currentDate,
              correlationId,
              hereHyperlinkURL
            );
          } else {
            message = httpErrorMessages[500](
              currentDate,
              null,
              hereHyperlinkURL
            );
          }

          break;
        case 502:
          message = httpErrorMessages[502](currentDate, hereHyperlinkURL);

          break;
        case 503:
          message = httpErrorMessages[503](currentDate, hereHyperlinkURL);

          break;
        case 504:
          message = httpErrorMessages[504](currentDate, hereHyperlinkURL);

          break;
        default:
          message = `<p><strong>Unknown Error ${
            status ? `(${status})` : ""
          }</strong></p><div><p>The service is temporarily unable to process your request. Alternatively, you may try following: </p></div>
          <div>
              <ul class="xb-ul">
              <li>Ensure the URL entered is correct.</li>
              <li>Reload the web page.</li>
              <li>Clear your browser’s cache / cookies.</li>
              </ul>
              <br />
              <p>If the issue persists, you can contact CEA via our feedback form <a style="text-decoration: underline;color: #145fac;" href="${hereHyperlinkURL}">HERE</a>.</p>
              <p>Date and Time : ${currentDate}</p>
          </div>
          `;
      }

      return message;
    },
    $_globalMixin_Dialog(error) {
      const status = error.response ? error.response.status : null;
      const condition =
        status === 401 || status === 403 || status === 404 || status === 408;

      if (!condition)
        this.$buefy.dialog.alert({
          message: this.$_globalMixin_errorMessage(error),
          confirmText: "Confirm",
          type: "is-danger",
          hasIcon: true
        });
    }
  }
};

export default globalMixin;
